// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 2143) return "app.css?v=06d415651737c9182f30";
	// return url for filenames based on template
	return "" + chunkId + ".css?v=" + {"2534":"9d7e358c8bff556767d8","6999":"32fe75de2b7da7808815"}[chunkId] + "";
};